// Port of api/fuel/app/classes/filter/search/games/filters/query/other.php
export default {
	name: 'other',
	priority: 105,
	require: function(config, filter) {
		return filter.source && filter.source.other && filter.source.other.length > 0
	},
	run: function(config, filter, data, query) {
		query.where('g.game_id', 'in', filter.source.other)
	}
}
